import { Stack } from "@mantine/core"
import { MIME_TYPES } from "@mantine/dropzone"
import { IconChecks } from "@tabler/icons-react"
import { Button, Card, DocumentUploader, FileListItem } from "@tfg/ui"
import { useState } from "react"
import { useTranslation } from "react-i18next"

import { ErrorPreview } from "~/pages/Admin/Ingestion/ProductImport/components/ErrorPreview"
import { ErrorLogs } from "~/pages/Brand/OrganizationSettings/Suppliers/hooks/useBatchCreateSuppliersMutation"
import { formatFileSize } from "~/utils/formatFileSize"

const MAX_FILE_SIZE = 5 * 1024 ** 2 // 5MB

type UploadDocumentProps = {
  importDocument: ({ file }: { file: File }) => void
  isLoading: boolean
  error: ErrorLogs | undefined
}

export function UploadDocument({
  importDocument,
  isLoading,
  error,
}: UploadDocumentProps) {
  const { t } = useTranslation()
  const [selectedFile, setSelectedFile] = useState<File>()

  return (
    <Card h="70%" w="100%">
      <Stack gap="var(--tfg-molecule-padding-y)">
        {selectedFile ? (
          <FileListItem
            fileName={selectedFile.name}
            onRemove={() => setSelectedFile(undefined)}
            w="100%"
            h="100%"
            size="lg"
          />
        ) : (
          <DocumentUploader
            onDrop={(files) => setSelectedFile(files[0])}
            maxFiles={1}
            width="100%"
            maxSize={MAX_FILE_SIZE}
            accept={[MIME_TYPES.csv]}
            title={t("documentUpload.title")}
            helpText={t("documentUpload.helptext", {
              maxSize: formatFileSize(),
            })}
          />
        )}
        <Button
          display="inline-block"
          variant="primary"
          onClick={() => {
            selectedFile && importDocument({ file: selectedFile })
          }}
          disabled={!selectedFile}
          icon={<IconChecks />}
          loading={isLoading}
        >
          {t("documentUpload.uploadSuppliers")}
        </Button>
        {error ? <ErrorPreview errorLogs={error} /> : null}
      </Stack>
    </Card>
  )
}
